<template>
        <div class="row top">
            <div class="row">
                <div class="col-md-2">
                    <back-button returnUrl="/Announcements/Index"></back-button>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <h4><u>Επεξεργασία Ανακοίνωσης</u></h4>
                </div>
            </div>
            <AnnouncementForm v-if="renderForm" :form="this.form" />
            <AnnouncementTableFilters :organizations="this.organizations" />
            <DxLoadIndicator id="image-indicator" :height="40" :width="40" :visible="loadIndicatorVisible" />
            <AnnouncementTable :organizations="this.organizations" />
            <button class="btn btn-warning" @click="onSubmit(true)">{{ isPublished ? "Ενημέρωση Δημοσίευσης" : "Δημοσίευση" }}</button>
            <button v-if="!isPublished" class="btn btn-primary" @click="onSubmit(false)">Ενημέρωση</button>
        </div>
</template>
<script>
import BackButton from "../../components/shared/backButton";
import DxLoadIndicator from "devextreme-vue/load-indicator";
import AnnouncementForm from "./Children/AnnouncementForm.vue";
import AnnouncementTableFilters from "./Children/OrganizationsTableFilters.vue";
import AnnouncementTable from "./Children/OrganizationsTable.vue";
import mainService from "../../services/mainService";
import notify from "devextreme/ui/notify";

export default {
    components: {
        BackButton,
        DxLoadIndicator,
        AnnouncementForm,
        AnnouncementTableFilters,
        AnnouncementTable,
    },
    data() {
        return {
            loadIndicatorVisible: false,
            form:{
                title: '',
                body: ''
            },
            isPublished:false,
            organizations: [],
            renderForm:false,
        }
    },
    async mounted() {
        this.loadIndicatorVisible = true;
        const announcement = await mainService.get(`/Announcements/GetAnnouncementAdmin?id=${this.$route.params.Id}`);
        this.form.title = announcement.data.Title;
        this.form.body = announcement.data.Body;
        this.isPublished = announcement.data.IsPublished
        this.renderForm = true;
        const organizations = await mainService.get(`/Organizations/GetOrganizationsForNewAnnouncement?id=${this.$route.params.Id}`);
        this.organizations = organizations.data;
        this.loadIndicatorVisible = false;
    },
    methods:{
        async onSubmit(publish){
            let announcement = {
                Id: this.$route.params.Id,
                Title: this.form.title,
                Body: this.form.body,
                OrganizationIds: this.organizations.filter(x => x.Send == true).map(x => x.OrganizationId),
                IsPublished: publish
            }
            if(publish && !this.validate(announcement))
                return;

            const result = await mainService.put('Announcements/UpdateAnnouncement',announcement);
            publish ? notify("Η δημοσίευση ενημερώθηκε!", "success", 3000) : notify("Η ανακοίνωση ενημερώθηκε!", "success", 3000)
        },
        validate(announcement){
            if(announcement.Title == ''){
                notify('θα πρέπει να εισάγετε τίτλο για να δημοσιευθεί η ανακοίνωση','error',3000)
                return false;
            }
            if(announcement.Body == ''){
                notify('θα πρέπει να εισάγετε κείμενο για να δημοσιευθεί η ανακοίνωση','error',3000)
                return false;
            }
            if(announcement.OrganizationIds.length == 0){
                notify('θα πρέπει να υπάρχει έστω και ένας οργανισμός επιλεγμένος για να δημοσιευθεί η ανακοίνωση','error',3000)
                return false;
            }
            return true;
        }
    }
}
</script>
<style scoped>
    .btn-warning{
        margin-left:10px;
    }
</style>